import bucmAxios from './bucm-axios';

export const createAssetForSubmission = (collaborationId: string, data: BUCM.CreateMediaAssetRequest) =>
    bucmAxios<BUCM.ApiResponse>({
        url: `/collaborations/${collaborationId}/media-assets`,
        data
    });
